// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2VTw9","errorLogs":"EditorFooter_errorLogs__JNmAG"};